import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { TextField, Button, Typography, Divider, Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Badge, Modal, Stack, Chip, Stepper, Step, StepLabel, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { Add, ArrowBack, ArrowForward, ArrowLeft, ArrowRight, Check, Close, Delete, DeleteOutline, Details, DockOutlined, FileOpen, Height, ListAlt, MinimizeOutlined, Print, ReplayOutlined, Save, Search, SearchOff, SearchOutlined, SearchRounded, Tune } from "@mui/icons-material";
import SideMenu from '../components/SideMenu';
import TopMenu from '../components/TopMenu';
import { pink, blue, teal, yellow, orange, indigo } from '@mui/material/colors';

const clientsList = [
  {customerNo: 1, customerName: "John Smith", addressLine: "A Line", city: "Atlanta", zip: "02882", phone: "1289-211", priceLevel: "L1"},
  {customerNo: 2, customerName: "John Smith", addressLine: "A Line", city: "Atlanta", zip: "02882", phone: "1289-211", priceLevel: "L1"},
  {customerNo: 3, customerName: "John Smith", addressLine: "A Line", city: "Atlanta", zip: "02882", phone: "1289-211", priceLevel: "L1"},
]

const styleModal = {
  position: 'absolute',
  top: '1%',
  left: '3%',
  width: '90%',
  height: '85vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

function SalesOrdersNew() {
  const { id } = useParams();
  // Sale order
  const [saleKind, setSaleKind] = useState(null);
  
  // Steps
  const [currentStep, setCurrentStep] = useState(1);
  const handleStep1 = (kind) => {
    setSaleKind(kind);
    if (kind === 'new') {
      setCurrentStep(3);
    } else {
      setCurrentStep(2);
    }
  };

  // Modal customers
  const [openModalCustomer, setOpenModalCustomer] = useState(false);
  const handleOpenModalCustomer = () => setOpenModalCustomer(true);
  const handleCloseModalCustomer = () => setOpenModalCustomer(false);
  
  // Modal products
  const [openModalProduct, setOpenModalProduct] = useState(false);
  const handleOpenModalProduct = () => setOpenModalProduct(true);
  const handleCloseModalProduct = () => setOpenModalProduct(false);

  // Modal quantity
  const [openModalQty, setOpenModalQty] = useState(false);
  const handleOpenModalQty = () => setOpenModalQty(true);
  const handleCloseModalQty = () => setOpenModalQty(false);

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Top menu */}
      <TopMenu />
      {/* Side menu */}
      <SideMenu />

      {/* Main container */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: 'background.default',
          p: 3,
          marginTop: '64px',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center' }} style={{marginTop: 20}}>
          <Box sx={{ width: '70%', pt: 3, pb: 3, pl: 1, pr: 1, borderBottom: '1px dotted #ccc' }}>
            <Stepper>
              <Step completed={currentStep === 1 ? true : false}>
                <StepLabel>{"New / Existent"}</StepLabel>
              </Step>
              <Step completed={currentStep === 2 ? true : false}>
                <StepLabel>{"Select order"}</StepLabel>
              </Step>
              <Step completed={currentStep === 3 ? true : false}>
                <StepLabel>{"Set order type"}</StepLabel>
              </Step>
              <Step completed={currentStep === 4 ? true : false}>
                <StepLabel>{"Customers"}</StepLabel>
              </Step>
              <Step completed={currentStep === 5 ? true : false}>
                <StepLabel>{"Catalogue"}</StepLabel>
              </Step>
            </Stepper>
          </Box>
        </Box>

        {/* STEP 1 */}
        {currentStep === 1 ?
          <Box sx={{ display: 'flex', justifyContent: 'center' }} style={{marginTop: 100}}>
            <Box sx={{ width: '80%', display: 'flex', justifyContent: 'space-between' }}>
              <Paper elevation={3} sx={{ background: indigo[500], pt: 4, pb: 4, width: '40%', cursor: 'pointer' }} onClick={() => handleStep1('new')}>
                <Typography variant="h6" component="h2" sx={{ color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <FileOpen /> <span style={{ marginLeft: 5 }}>New order</span>
                </Typography>
              </Paper>

              <Paper elevation={3} sx={{ background: indigo[500], pt: 4, pb: 4, width: '40%', cursor: 'pointer' }} onClick={() => handleStep1('list')}>
                <Typography variant="h6" component="h2" sx={{ color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <ListAlt /> <span style={{ marginLeft: 5 }}>Sales order list</span>
                </Typography>
              </Paper>
            </Box>
          </Box>
        : null}


        {/* STEP 2 */}
        {currentStep === 2 ?
          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }} style={{marginTop: 40}}>
            <Paper elevation={3} sx={{ width: '70%', mb: 3 }}>
              <Box sx={{ display: 'flex', gap: 2, pt: 2, pb: 2, width: '100%' }}>
                <Box sx={{ width: '20%' }}>
                  <Stack direction="row" spacing={1} sx={{ width: '100%', justifyContent: 'center' }}>
                    <Chip label="Existing sale order" color="primary" variant="outlined" />
                  </Stack>

                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Button variant="contained" startIcon={<ArrowBack />} sx={{ backgroundColor: indigo[100], color: indigo[500] }} onClick={() => setCurrentStep(1)}>
                      Back
                    </Button>
                  </Box>
                </Box>

                <Box sx={{ width: '40%' }}>
                  <Typography variant='body1' color='gray'>
                    Order No: 
                  </Typography> 
                  <Typography variant='body1' color='gray'>
                    Person No: 
                  </Typography> 
                  <Typography variant='body1' color='gray'>
                    Price level: 
                  </Typography> 
                  <Typography variant='body1' color='gray'>
                    Customer No: 
                  </Typography>
                </Box>

                <Box sx={{ width: '40%' }}>
                  <Typography variant='body1' color='gray'>
                    Customer name: 
                  </Typography> 
                  <Typography variant='body1' color='gray'>
                    Sale order type: 
                  </Typography> 
                  <Typography variant='body1' color='gray'>
                    Type of packaging: 
                  </Typography> 
                  <Typography variant='body1' color='gray'>
                    Weighed: 
                  </Typography> 
                </Box>
              </Box>
            </Paper>

            <Box sx={{ width: '70%' }}>
              <Paper sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  <Typography variant="h6" component="h2" sx={{ color: indigo[500], mb: 0 }}>
                    Sales orders
                  </Typography>

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '60%' }}>
                    <TextField label="Search by item code or description" variant="outlined" size="small" />
                    <Button variant="contained" sx={{ backgroundColor: indigo[500], color: '#fff', ml: 1 }}><SearchRounded /></Button>
                    <Button variant="contained" sx={{ backgroundColor: indigo[500], color: '#fff', ml: 1 }}><ReplayOutlined /></Button>
                  </Box>
                </Box>

                <TableContainer component={Paper} sx={{ mt: 4 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Item code</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Quantity</TableCell>
                        <TableCell>Weight</TableCell>
                        <TableCell>Total weight</TableCell>
                        <TableCell>Unit price</TableCell>
                        <TableCell>Total</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {clientsList.map((item) => {
                        return (
                          <TableRow>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">
                              <Button variant="outlined" size="small" sx={{ borderColor: blue[800], color: blue[800], ml: 1 }} onClick={() => setCurrentStep(5)}><ArrowForward /></Button>
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Box>
          </Box>
        : null}

        {/* STEP 3 */}
        {currentStep === 3 ?
          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }} style={{marginTop: 40}}>
            <Paper elevation={3} sx={{ width: '70%', mb: 3 }}>
              <Box sx={{ display: 'flex', gap: 2, pt: 2, pb: 2, width: '100%' }}>
                <Box sx={{ width: '20%' }}>
                  <Stack direction="row" spacing={1} sx={{ width: '100%', justifyContent: 'center' }}>
                    <Chip label="New sale order" color="primary" variant="outlined" />
                  </Stack>

                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Button variant="contained" startIcon={<ArrowBack />} sx={{ backgroundColor: indigo[100], color: indigo[500] }} onClick={() => setCurrentStep(1)}>
                      Back
                    </Button>
                  </Box>
                </Box>

                <Box sx={{ width: '40%' }}>
                  <Typography variant='body1'>
                    Order No: ***
                  </Typography> 
                  <Typography variant='body1'>
                    Person No: ***
                  </Typography> 
                  <Typography variant='body1'>
                    Price level: ***
                  </Typography> 
                  <Typography variant='body1' color='gray'>
                    Customer No: 
                  </Typography>
                </Box>

                <Box sx={{ width: '40%' }}>
                  <Typography variant='body1' color='gray'>
                    Customer name: 
                  </Typography> 
                  <Typography variant='body1' color='gray'>
                    Sale order type: 
                  </Typography> 
                  <Typography variant='body1' color='gray'>
                    Type of packaging: 
                  </Typography> 
                  <Typography variant='body1' color='gray'>
                    Weighed: 
                  </Typography> 
                </Box>
              </Box>
            </Paper>

            <Paper elevation={3} sx={{ p: 2, width: '60%', display: 'flex', justifyContent: 'center' }}>
              <Box sx={{ width: '60%' }}>
                <br />

                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Sales order type</InputLabel>
                  <Select
                    value={'Standard'}
                    label="Sales order type"
                    onChange={() => {}}
                  >
                    <MenuItem value={'Standard'}>Standard</MenuItem>
                    <MenuItem value={'Quote'}>Quote</MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Type of packaging</InputLabel>
                  <Select
                    value={'Transparent stretch wrap'}
                    label="Type of packaging"
                    onChange={() => {}}
                  >
                    <MenuItem value={'Transparent stretch wrap'}>Transparent stretch wrap</MenuItem>
                    <MenuItem value={'Black stretch wrap'}>Black stretch wrap</MenuItem>
                    <MenuItem value={'No packaging (Customer collect)'}>No packaging (Customer collect)</MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Need to be weighed?</InputLabel>
                  <Select
                    value={'Weighed'}
                    label="Need to be weighed?"
                    onChange={() => {}}
                  >
                    <MenuItem value={'Weighed'}>Weighed</MenuItem>
                    <MenuItem value={'No need to be weighed'}>No need to be weighed</MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button variant="contained" startIcon={<Check />} sx={{ mb: 2, ml: 1, backgroundColor: indigo[500], color: '#fff' }} onClick={() => setCurrentStep(4)}>
                      Confirm
                    </Button>
                  </Box>
                </FormControl>
              </Box>
            </Paper>

          </Box>
        : null}


        {/* STEP 4 */}
        {currentStep === 4 ? 
          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }} style={{marginTop: 40}}>
            <Paper elevation={3} sx={{ width: '70%', mb: 3 }}>
              <Box sx={{ display: 'flex', gap: 2, pt: 2, pb: 2, width: '100%' }}>
                <Box sx={{ width: '20%' }}>
                  <Stack direction="row" spacing={1} sx={{ width: '100%', justifyContent: 'center' }}>
                    <Chip label="New sale order" color="primary" variant="outlined" />
                  </Stack>

                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Button variant="contained" startIcon={<ArrowBack />} sx={{ backgroundColor: indigo[100], color: indigo[500] }} onClick={() => setCurrentStep(3)}>
                      Back
                    </Button>
                  </Box>
                </Box>

                <Box sx={{ width: '40%' }}>
                  <Typography variant='body1'>
                    Order No: ***
                  </Typography> 
                  <Typography variant='body1'>
                    Person No: ***
                  </Typography> 
                  <Typography variant='body1'>
                    Price level: ***
                  </Typography> 
                  <Typography variant='body1' color='gray'>
                    Customer No: 
                  </Typography>
                </Box>

                <Box sx={{ width: '40%' }}>
                  <Typography variant='body1' color='gray'>
                    Customer name: 
                  </Typography> 
                  <Typography variant='body1'>
                    Sale order type: ***
                  </Typography> 
                  <Typography variant='body1'>
                    Type of packaging: ***
                  </Typography> 
                  <Typography variant='body1'>
                    Weighed: ***
                  </Typography> 
                </Box>
              </Box>
            </Paper>

            <Box sx={{ width: '80%' }}>
              <Paper sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  <Typography variant="h6" component="h2" sx={{ color: indigo[500], mb: 0 }}>
                    Customers
                  </Typography>

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                    <TextField label="Search by item code or description" variant="outlined" size="small" />
                    <Button variant="contained" sx={{ backgroundColor: indigo[500], color: '#fff', ml: 1 }}><SearchRounded /></Button>
                    <Button variant="contained" sx={{ backgroundColor: indigo[500], color: '#fff', ml: 1 }}><ReplayOutlined /></Button>
                  </Box>
                </Box>

                <TableContainer component={Paper} sx={{ mt: 4 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Customer No</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Customer name</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Address line</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>City</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Zip code</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Telephone</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Price level</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {clientsList.map((item) => {
                        return (
                          <TableRow>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerName}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.addressLine}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.city}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.zip}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.phone}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.priceLevel}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">
                              <Button variant="outlined" size="small" sx={{ borderColor: blue[500], color: blue[500], ml: 1 }} onClick={() => setCurrentStep(5)}><ArrowForward /></Button>
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Box>
          </Box>
        : null}


        {/* STEP 5 */}
        {currentStep === 5 ? 
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }} style={{marginTop: 40}}>
            <Paper elevation={3} sx={{ width: '70%', mb: 3 }}>
              <Box sx={{ display: 'flex', gap: 2, pt: 2, pb: 2, width: '100%' }}>
                <Box sx={{ width: '20%' }}>
                  <Stack direction="row" spacing={1} sx={{ width: '100%', justifyContent: 'center' }}>
                    <Chip label="New sale order" color="primary" variant="outlined" />
                  </Stack>

                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Button variant="contained" startIcon={<ArrowBack />} sx={{ backgroundColor: indigo[100], color: indigo[500] }} onClick={() => setCurrentStep(4)}>
                      Back
                    </Button>
                  </Box>
                </Box>

                <Box sx={{ width: '40%' }}>
                  <Typography variant='body1'>
                    Order No: ***
                  </Typography> 
                  <Typography variant='body1'>
                    Person No: ***
                  </Typography> 
                  <Typography variant='body1'>
                    Price level: ***
                  </Typography> 
                  <Typography variant='body1'>
                    Customer No: ***
                  </Typography>
                </Box>

                <Box sx={{ width: '40%' }}>
                  <Typography variant='body1'>
                    Customer name: ***
                  </Typography> 
                  <Typography variant='body1'>
                    Sale order type: ***
                  </Typography> 
                  <Typography variant='body1'>
                    Type of packaging: ***
                  </Typography> 
                  <Typography variant='body1'>
                    Weighed: ***
                  </Typography> 
                </Box>
              </Box>
            </Paper>

            <Box sx={{ width: '48%' }}>
              <Paper sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  <Typography variant="h6" component="h2" sx={{ color: indigo[500], mb: 0 }}>
                    Catalogue
                  </Typography>

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                    <TextField label="Search by item code or description" variant="outlined" size="small" />
                    <Button variant="contained" sx={{ backgroundColor: indigo[500], color: '#fff', ml: 1 }}><SearchRounded /></Button>
                    <Button variant="contained" sx={{ backgroundColor: indigo[500], color: '#fff', ml: 1 }}><ReplayOutlined /></Button>
                  </Box>
                </Box>

                <TableContainer component={Paper} sx={{ mt: 4 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>ID</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Name</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Unit price</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>On hand</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {clientsList.map((item) => {
                        return (
                          <TableRow>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">
                              <div style={{ width: 100, height: 60, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <img src="https://mayaland-src.s3.us-east-2.amazonaws.com/700719.jpg" alt="" style={{ width: '100%' }} />
                              </div>
                              <p>
                                <Chip label="# 700719" color="primary" variant="outlined" />
                              </p>
                            </TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">
                              719 FUD ORIGINAL BACON 16/12OZ FUD
                            </TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">
                              <b>Unit price: $105.05</b>                              
                            </TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">
                              2
                            </TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">
                              <Button variant="outlined" size="small" sx={{ borderColor: blue[500], color: blue[500], ml: 1 }} onClick={() => handleOpenModalQty()}><ArrowForward /></Button>
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Box>

            <Box sx={{ width: '48%' }}>
              <Paper sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  <Typography variant="h6" component="h2" sx={{ color: indigo[500], mb: 0 }}>
                    Sale order
                  </Typography>

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '60%' }}>
                    <TextField label="Search by item code or description" variant="outlined" size="small" />
                    <Button variant="contained" sx={{ backgroundColor: indigo[500], color: '#fff', ml: 1 }}><SearchRounded /></Button>
                    <Button variant="contained" sx={{ backgroundColor: indigo[500], color: '#fff', ml: 1 }}><ReplayOutlined /></Button>
                  </Box>
                </Box>

                <TableContainer component={Paper} sx={{ mt: 4 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Item code</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Quantity</TableCell>
                        <TableCell>Weight</TableCell>
                        <TableCell>Total weight</TableCell>
                        <TableCell>Unit price</TableCell>
                        <TableCell>Total</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {clientsList.map((item) => {
                        return (
                          <TableRow>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">{item.customerNo}</TableCell>
                            <TableCell sx={{ pt: 2, pb: 2 }} align="center">
                              <Button variant="outlined" size="small" sx={{ borderColor: pink[800], color: pink[800], ml: 1 }}><DeleteOutline /></Button>
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Box>
          </Box>
        : null}

      </Box>
      

      {/* Modal quantity */}
      <Modal
        open={openModalQty}
        onClose={handleCloseModalQty}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{...styleModal, width: '30%', top: '30%', left: '33%', height: '15vh'}}>
          <Typography variant="h6" component="h2" sx={{ color: indigo[500], textAlign: 'center', mb: 2 }}>
            719 FUD ORIGINAL BACON 16/12OZ FUD
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', width: '100%' }}>
            <TextField label="1" variant="outlined" size="small" sx={{ width: '100%' }} />

            <Button variant="contained" sx={{ backgroundColor: indigo[500], color: '#fff', mt: 1, mb: 4 }} onClick={ () => handleCloseModalQty() }>Confirm quantity</Button>
          </Box>
          <br />
        </Box>
      </Modal>


      {/* Modal cutomer */}
      <Modal
        open={openModalCustomer}
        onClose={handleCloseModalCustomer}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ color: indigo[500] }}>
              Customers
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
              <TextField label="Search by item code or description" variant="outlined" size="small" />
              <Button variant="contained" sx={{ backgroundColor: indigo[500], color: '#fff', ml: 1 }}><SearchRounded /></Button>
              <Button variant="contained" sx={{ backgroundColor: indigo[500], color: '#fff', ml: 1 }}><ReplayOutlined /></Button>
              <Button variant="outlined" onClick={() => handleCloseModalCustomer()} sx={{ borderColor: pink[800], color: pink[900], ml: 1 }}><Close /></Button>
            </Box>
          </Box>

          <TableContainer component={Paper} sx={{ mt: 4 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Customer No</TableCell>
                  <TableCell>Customer name</TableCell>
                  <TableCell>Address line</TableCell>
                  <TableCell>City</TableCell>
                  <TableCell>Zip code</TableCell>
                  <TableCell>Telephone</TableCell>
                  <TableCell>Price level</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell colSpan={6} align="center">No data available</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>


      {/* Modal products */}
      <Modal
        open={openModalProduct}
        onClose={handleCloseModalProduct}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ color: indigo[500] }}>
              Catalogue
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
              <TextField label="Search by Name or No" variant="outlined" size="small" />
              <Button variant="contained" sx={{ backgroundColor: indigo[500], color: '#fff', ml: 1 }}><SearchRounded /></Button>
              <Button variant="contained" sx={{ backgroundColor: indigo[500], color: '#fff', ml: 1 }}><ReplayOutlined /></Button>
              <Button variant="outlined" onClick={() => handleCloseModalProduct()} sx={{ borderColor: pink[800], color: pink[900], ml: 1 }}><Close /></Button>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 4 }}>
            <Paper sx={{ width: '30%', p: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                <div style={{ width: '60%', height: 150, marginTop: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <img src="https://mayaland-src.s3.us-east-2.amazonaws.com/700719.jpg" alt="" />
                </div>

                <Stack direction="row" spacing={1} sx={{ mt: 2, mb: 2, width: '80%', justifyContent: 'center' }}>
                  <Chip label="# 700719" color="primary" variant="outlined" />
                  <Chip label="On hand: 2" color="primary" variant="outlined" />
                </Stack>

                <div style={{ borderBottomWidth: 1, borderBottomColor: '#ccc', borderBottomStyle: 'dotted', height: 1, width: '80%' }}></div>
                
                <Typography variant="body1" gutterBottom={false} sx={{ m: 1, p: 0, width: '100%', textAlign: 'center' }}>
                  719 FUD ORIGINAL BACON 16/12OZ FUD
                </Typography>
                <Typography variant="body1" gutterBottom={false} sx={{ m: 0, p: 0, width: '100%', textAlign: 'center' }}>
                  <b>Unit price: $105.05</b>
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '50%', mt: 3 }}>
                  <Button variant="contained" sx={{ backgroundColor: pink[800], color: '#fff', mr: 1 }}><Delete /></Button>
                  <TextField label="0" variant="outlined" size="small" />
                </Box>
              </Box>
            </Paper>

            <Paper sx={{ width: '30%', p: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                <div style={{ width: '60%', height: 150, marginTop: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <img src="https://mayaland-src.s3.us-east-2.amazonaws.com/700719.jpg" alt="" />
                </div>

                <Stack direction="row" spacing={1} sx={{ mt: 2, mb: 2, width: '80%', justifyContent: 'center' }}>
                  <Chip label="# 700719" color="primary" variant="outlined" />
                  <Chip label="On hand: 2" color="primary" variant="outlined" />
                </Stack>

                <div style={{ borderBottomWidth: 1, borderBottomColor: '#ccc', borderBottomStyle: 'dotted', height: 1, width: '80%' }}></div>
                
                <Typography variant="body1" gutterBottom={false} sx={{ mt: 1, p: 0, width: '100%', textAlign: 'center' }}>
                  719 FUD ORIGINAL BACON 16/12OZ FUD
                </Typography>
                <Typography variant="body1" gutterBottom={false} sx={{ m: 0, p: 0, width: '100%', textAlign: 'center' }}>
                  <b>Unit price: $105.05</b>
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '50%', mt: 3 }}>
                  <Button variant="contained" sx={{ backgroundColor: pink[800], color: '#fff', mr: 1 }}><Delete /></Button>
                  <TextField label="0" variant="outlined" size="small" />
                </Box>
              </Box>
            </Paper>
          </Box>
        </Box>
      </Modal>

    </Box>
  );
}

export default SalesOrdersNew;
